export const getCookieItem = key => {
  if (typeof window !== undefined && window.document) {
    const cookieItems = document.cookie.split('; ')

    return (cookieItems.filter(item => item.indexOf(key) > -1)[0] || '').split('=')[1]
  } else {
    return
  }
}

export const setCookieItem = (key, value, options = {}) => {
  if (typeof window !== 'undefined' && window.document) {
    // 默认选项
    const defaultOptions = {
      expires: null,    // 过期时间（天数或Date对象）
      path: '/',        // 路径
      domain: null,     // 域名
      secure: false,    // 是否只在HTTPS下发送
      sameSite: 'Lax'   // SameSite策略
    }

    const config = { ...defaultOptions, ...options }

    // 构建cookie字符串
    let cookieString = `${key}=${encodeURIComponent(value)}`

    // 添加路径
    if (config.path) {
      cookieString += `; path=${config.path}`
    }

    // 添加域名
    if (config.domain) {
      cookieString += `; domain=${config.domain}`
    }

    // 添加过期时间
    if (config.expires) {
      let expiresDate

      if (typeof config.expires === 'number') {
        // 如果是数字，表示天数
        expiresDate = new Date()
        expiresDate.setTime(expiresDate.getTime() + (config.expires * 24 * 60 * 60 * 1000))
      } else if (config.expires instanceof Date) {
        // 如果是Date对象
        expiresDate = config.expires
      }

      if (expiresDate) {
        cookieString += `; expires=${expiresDate.toUTCString()}`
      }
    }

    // 添加secure
    if (config.secure) {
      cookieString += '; secure'
    }

    // 添加SameSite
    if (config.sameSite) {
      cookieString += `; samesite=${config.sameSite}`
    }

    // 设置cookie
    document.cookie = cookieString
  }
}